var ImpersonateOutput = /** @class */ (function () {
    function ImpersonateOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImpersonateOutput.prototype.init = function (data) {
        if (data) {
            this.impersonationToken = data["impersonationToken"];
            this.tenancyName = data["tenancyName"];
        }
    };
    ImpersonateOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ImpersonateOutput();
        result.init(data);
        return result;
    };
    ImpersonateOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    };
    ImpersonateOutput.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ImpersonateOutput();
        result.init(json);
        return result;
    };
    return ImpersonateOutput;
}());
export { ImpersonateOutput };
